import "./i18n";
import { EXTERNALS_LIST as BASE_EXTERNALS_LIST, EXTERNALS_CREATE as BASE_EXTERNALS_CREATE, EXTERNALS_EDIT as BASE_EXTERNALS_EDIT, EXTERNALS_VIEW as BASE_EXTERNALS_VIEW, } from "./config/routes";
export const EXTERNALS_LIST = {
    ...BASE_EXTERNALS_LIST,
};
export const EXTERNALS_CREATE = {
    ...BASE_EXTERNALS_CREATE,
};
export const EXTERNALS_EDIT = {
    ...BASE_EXTERNALS_EDIT,
};
export const EXTERNALS_VIEW = {
    ...BASE_EXTERNALS_VIEW,
};
